// import { logEvent } from "@amplitude/analytics-browser";
import { Api } from "../uikit/service/api";
import { useDispatch, useSelector } from "react-redux";
import { editorActions } from "../store/editor";
import useObjectRelationGqlRequest from "./useObjectRelationGqlRequest";
import func from "@uikit/func";
import store from "../store";
import { UserIdentity } from "@uikit/util/userIdentity";
import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { getIt } from "@uikit/getIt";
import { MeStore } from "imagica-corekit/dist/base/store/MeStore";
import { logEvent } from "@uikit/service/amplitude";
import { useSignal } from "@preact/signals-react";

export default function useUserAuth() {
  const dispatch = useDispatch();

  const meLoading = useSelector(state => (state as any).editor.meLoading);
  const setMeLoading = (val: any) => {
    dispatch(editorActions.setMeLoading(val));
  };

  const userSuccess = useSignal(false);
  const [userMeError, setUserMeError] = useState(null);
  const subscriberParamsData = useSelector((state: any) => state.editor.subscriberParamsData);
  const [searchParams] = useSearchParams();

  const isSubscriber =
    subscriberParamsData?.attributes?.mode === "subscriber" || searchParams.get("mode") === "subscriber";

  const setMe = (val: any) => {
    dispatch(editorActions.setMe(val));
  };

  const { gql } = useObjectRelationGqlRequest();

  useEffect(() => {
    if (UserIdentity.hasGuest()) {
      setMeLoading(false);
      setUserMeError(null);
    }
  }, []);

  const fetchUserMe = useCallback(async (shareQ?: string) => {
    try {
      setMeLoading(true);
      setUserMeError(null);
      const api = new Api(false);

      const res = await api.getWithError("/api/users/me.json");

      // throw "Failed to get user info";

      // 这里给me赋值确保权限判定逻辑不会因为下面的请求报错而导致判定错误
      setMe(res.data);

      /// 赋值给corekit避免那边重复调用
      /// 后面应优化为：fot、corekit都直接使用corekit的MeStore这个业务对象
      getIt(MeStore).receive(res.data);

      const meObj = res?.data?.is_guest ? {} : await gql.query.me();
      // res.data.objectId = meObj.objectId;
      const me = Object.assign({}, res.data, { objectId: meObj.objectId });
      if (func.isEmpty(me)) {
        throw "Failed to get user info";
      }
      // getImagicaStudioTutorial(me)
      setMe(me);
      if (store.getState().editor.isClickSignup) {
        logEvent("signup");
      }
      if (store.getState().editor.isClickLogin) {
        if (shareQ) {
          const result = await api.get("/api/studios/" + shareQ);
          const formData = await result.json();
          logEvent("webapp_login", { guest_uuid: shareQ, project_static_id: formData.attributes.project_id }); //TODO: add event properties
        } else {
          logEvent("login"); //TODO: add event properties
        }
      }

      setMeLoading(false);
    } catch (error: any) {
      console.error("error:::", error);
      setUserMeError(error);
      throw error;
    } finally {
      // setMeLoading(false);
      userSuccess.value = true;
    }
  }, []);

  // 第二个参数boo用来跳过userme 获取
  const getUserMe = async (shareQ?: string, boo?: boolean) => {
    if (boo) {
      userSuccess.value = true;
      return;
    }
    // TODO: 当登录成功后，进入 homeUsePlugin 是否需要二次刷新 Me
    // if (!UserIdentity.hasGuest()) {
    // TAG: 912
    try {
      await fetchUserMe(shareQ);
    } catch (error: any) {
      /// 在api.getWithError 中已经处理401 错误(进入登录页面) 这儿不再需要抛出错误
      if (error?.response?.status === 401) return;
      return Promise.reject(error);
    }
    // }
  };

  return {
    userMeState: {
      success: userSuccess.value,
      loading: meLoading,
    },
    /**
     * 判断用户是否为订阅者
     */
    isSubscriber,
    getUserMe,
  };
}
